/**
 * @fileoverview Input/output schemas for world-place-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world place's details.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.activeWorldPlace.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

/**
 * A creative direction for place development.
 */
export const WorldPlaceDetailsIdeaSchema = z.object({
  title: z.string().describe('A short, evocative title for this creative direction.'),
  summary: z.string().describe("A detailed summary of the place's history, atmosphere, significance, and narrative implications."),
});

export type WorldPlaceDetailsIdea = z.infer<typeof WorldPlaceDetailsIdeaSchema>;

export const OutputSchema = z.object({
  ideas: z.array(WorldPlaceDetailsIdeaSchema).length(3).describe('An array of exactly three distinct place detail concepts.'),
});

export type Output = z.infer<typeof OutputSchema>;
